module.exports = __webpack_public_path__ + "media/svg-new/support-blue-astronauta-befe1411.svg";